import { FEATURE_FLAGS } from '../../../constants/featureFlags';
import { useTeamQuery } from '../../../graphql/team/queryTeam';
import type { NexoyaTeamFeatureFlag } from '../../../types';
import { isFeatureFlagEnabled } from '../../../utils/featureFlags';

export type LabelsFlags = {
  /** Render the old, portfolio-scoped labels UI. False only when the team opted into hiding it. */
  legacyEnabled: boolean;
  /** Render the new team-scoped Content Labels UI. */
  v2Enabled: boolean;
  /**
   * The team — and therefore its flag list — is KNOWN. Until it is, `featureFlags` is `[]`,
   * which reads as "v2 off, legacy on": anything with a loading state of its own must report
   * it while this is false (`src/hooks/useContentLabelCategories`).
   */
  resolved: boolean;
};

type FlagLike = Pick<NexoyaTeamFeatureFlag, 'name' | 'status'> | null | undefined;

/**
 * Both label systems can be live at once: v2 is not wired to the old labels and nothing is
 * migrated, so `FeatureSwitch`'s either/or ternary cannot express this. Hiding the old
 * labels is opt-IN (`hide_legacy_portfolio_labels`) so a team without the flag keeps them.
 */
export function useLabelsFlags(): LabelsFlags {
  const teamQuery = useTeamQuery();

  const team = teamQuery?.data?.team;
  const featureFlags: ReadonlyArray<FlagLike> = team?.featureFlags ?? [];

  return {
    legacyEnabled: !isFeatureFlagEnabled(featureFlags, FEATURE_FLAGS.HIDE_LEGACY_PORTFOLIO_LABELS),
    v2Enabled: isFeatureFlagEnabled(featureFlags, FEATURE_FLAGS.LABELS_V2),
    resolved: team != null,
  };
}
